import React from "react";
import { CheckCircle2, Circle } from "lucide-react";

const TIMELINE_STEPS = [
  { key: "solicitacao", label: "Solicitação" },
  { key: "triagem", label: "Triagem" },
  { key: "analise", label: "Análise" },
  { key: "consultor_designado", label: "Designado" },
  { key: "clinica_selecionada", label: "Clínica" },
  { key: "reserva_confirmada", label: "Reserva" },
  { key: "internado", label: "Internação" },
  { key: "concluido", label: "Concluído" },
];

export const CaseTimeline = ({ timeline = [] }) => {
  const doneSteps = new Set(timeline.map((t) => t.step));
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 mb-6 overflow-x-auto">
      <ol className="flex items-center gap-2 min-w-max">
        {TIMELINE_STEPS.map((s, i) => {
          const done = doneSteps.has(s.key);
          return (
            <React.Fragment key={s.key}>
              <li className="flex items-center gap-2">
                {done ? <CheckCircle2 className="w-5 h-5 text-green-600" /> : <Circle className="w-5 h-5 text-slate-300" />}
                <span className={`text-xs ${done ? "text-slate-800 font-medium" : "text-slate-400"}`}>{s.label}</span>
              </li>
              {i < TIMELINE_STEPS.length - 1 && <div className={`h-px w-6 ${done ? "bg-green-600" : "bg-slate-200"}`} />}
            </React.Fragment>
          );
        })}
      </ol>
    </div>
  );
};
